import { render, staticRenderFns } from "./compLogClubInto.vue?vue&type=template&id=bac2ae98&scoped=true&"
import script from "./compLogClubInto.vue?vue&type=script&lang=js&"
export * from "./compLogClubInto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac2ae98",
  null
  
)

export default component.exports